import { formatAmounts } from '@aytm/app/stats/lib/util/helpers'
import { processText } from '@aytm/app/stats/page/components/lib/utils'

// Palette length: batch colour indices cycle modulo this size.
const PALETTE_SIZE = 21

// Ties are broken by item position so the order is stable across equal values.
const byPosition = (a, b, dir) => dir * (a.position - b.position)
const byValue = key => (a, b, dir) =>
  dir * (a.cells[1][key] + a.position / 10000 - (b.cells[1][key] + b.position / 10000))

// Which column the persisted sort token points at, and in which direction. Item-sorted
// tokens start with `i`, value-sorted ones with `v`; the suffix carries the direction.
const applySorted = (cols, sortOrder = 'iasc') => {
  const colIndex = 'i' === sortOrder[0] ? 0 : cols.length - 1
  const dir = 'asc' === sortOrder.slice(1) ? 1 : -1

  return cols.map((col, index) => (index === colIndex ? { ...col, sorted: dir } : col))
}

const valueColTitle = ({ answer, hasBase, hideTotal }) => {
  if (hasBase) return `<small>(based on ${formatAmounts(answer, ['base', 'total'])} responses)</small>`

  return `Units${hideTotal ? '' : `<small>(from ${formatAmounts(answer, 'total')} resp.)</small>`}`
}

export const calcTableProps = ({ answer, batches = [], viewMode, format, percentDecimals, sortOrder, onSort }) => {
  const isLoading = 'loading' == answer
  const values = isLoading || answer == undefined ? {} : answer

  const hasBase =
    Object.hasOwn(values, 'base') ||
    Object.keys(values).some(key => values[key] != undefined && Object.hasOwn(values[key], 'base'))
  const hideTotal = true === format?.hideTotal

  const isRaw = 'raw' === viewMode
  const valueKey = isRaw ? 'value' : 'percents'

  const cols = [
    { type: 'title', title: 'Alternatives (compared items)', sort: byPosition },
    isRaw
      ? {
          type: 'value',
          title: valueColTitle({ answer: values, hasBase, hideTotal }),
          width: 150,
          sort: byValue('value'),
          format: value => formatAmounts(value)
        }
      : {
          type: 'progress',
          title: valueColTitle({ answer: values, hasBase, hideTotal }),
          percentDecimals,
          sort: byValue('percents')
        }
  ]

  const rows = batches.map(batch => {
    const item = values[`b${batch.position}`] || {}

    return {
      cells: [
        {
          title: processText(batch.text),
          label: `A${batch.position}`,
          colorIndex: ((batch.position - 1) % PALETTE_SIZE) + 1
        },
        { [valueKey]: item[viewMode] || 0, loading: isLoading }
      ],
      position: batch.position
    }
  })

  return { cols: applySorted(cols, sortOrder), rows, onSort }
}
